import { combineReducers } from 'redux';
import authReducer from '../../features/auth/authSlice';
import applicationReducer from '../../features/application/applicationDetailsSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  applicationDetails: applicationReducer,
});

export default rootReducer;